import React from 'react';
import {favoriteBetsStore} from "../store/favoriteBetsStore";
import {userInfoStore} from "@pascal/pascal-core/shared/core/store";
import {doChipStore} from "../store/doChipStore";
import {winningAmountStore} from "../store/winningAmountStore";
import {autoBetStore} from "../store/autoBetStore";
import {gameStore} from "../store/gameStore";

export const useClearDemoStore = () => {

  const clearDemoStateHandler = () => {
    favoriteBetsStore.setFavoriteBes([]);
    // userInfoStore.setDemoBalance(10000);
    doChipStore.resetReBet();
    doChipStore.resetAllBetsModels(true);
    winningAmountStore.setWinningAmount(null);
    winningAmountStore.setWinNumber(null);
    autoBetStore.resetAutoBet();
    winningAmountStore.setLastWin(0);
  }


  return {
    clearDemoStateHandler,
  };
};
